function initPriceRange() {
  const exact = document.querySelector('[data-price-display]');
  const range = document.querySelector('[data-price-range]');
  if (exact && range) {
    exact.style.display = 'none';
    range.style.display = '';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPriceRange);
} else {
  initPriceRange();
}
